import React, {useEffect,useState,useMemo,useRef} from 'react';
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import GetRequest from '../../service/GetRequest';
import Breadcrumb from './Breadcrump';
import { Badge } from 'primereact/badge';
import { Button } from 'primereact/button';
import { OverlayPanel } from 'primereact/overlaypanel';
import CookieHandler from '../../pages/LandingPage/Authentication/CookieHandler'
import "./headerStyle.css";


const DashboardPageHeader = ({activePath,toggleSidebar }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [isDemoGraphicsScrolled, setIsDemoGraphicsScrolled] = useState(false);

  const userId = CookieHandler.getCookie("useId");
  const op = useRef(null);

  const isLoggedIn = CookieHandler.getCookie("isLoggedIn");
  const permittedRoutes = useMemo(() => [
    "/store/package-selection",
    "/store/register",
    "/store/add/products",
    "/store/add/categories",
    "/store/add/new/branch/:storeId",
    "/store/add/branch/:storeId",
    "/store/branches/list",
    "/store/intiate/deploy/:storeId",
], []);

useEffect (()=>{
  if(!isLoggedIn){
      navigate('/login');
  } else {
  GetRequest("v1/store-management-service/view/manager",true)
  .then(response=>{
      if(!response || response === undefined){
          console.log("Error fecthing details");
          } else {
              if(response.isSubscribed===true){
                GetRequest("v1/store-management-service/view/my/store",true)
                .then(response=>{
                    if(!response || response === undefined){
                            console.log("No store found for this user")
                            const currentRoute = window.location.pathname;
                            if (!permittedRoutes.includes(currentRoute)) {
                              // setTimeout(() => {
                              //   navigate("/store/complete/profile");
                              // }, 2000);
                            }
              
                        } else {
                          CookieHandler.setCookie('storeId', response.id);
                        }      
                    
                })   
              } else {
                  // navigate("/store/package-selection");
              }
          }       
  })   
} 
},[navigate,isLoggedIn, userId, permittedRoutes]);

const handleLogout = () => {
  CookieHandler.clear();
  CookieHandler.setCookie('isLoggedIn', 'false');
  navigate('/login');
};

  const menuItems = [
    { id: 'bossMagicSection', label: 'Boss Magic' },
    { id: 'keyFeaturesSection', label: 'Key Features' },
    { id: 'pricingSection', label: 'Pricing' },
    { id: 'contactusSection', label: 'Contact us' },
  ];

  return (
    <div className='outlet-container'>
        <div className="dashboard-header-container">
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
              <div className="lg:hidden flex align-items-center justify-content-center">
                  <button type="button" className="p-link layout-menu-button layout-topbar-button" onClick={toggleSidebar}>
                                                  <i className="pi pi-bars" />
                  </button>
              </div>
              <div className="dashboard-header-name">{activePath}
              </div>
              <div className="hidden md:flex align-items-center justify-content-center">
              <Breadcrumb />
            </div>
          </div>
            <div className="dashboard-action-bar">
            <i className="pi pi-bell p-overlay-badge" style={{ fontSize: '1.5rem' }}>
                <Badge value="2"></Badge>
            </i>
            <Button icon="pi pi-user" rounded text aria-label="Filter" onClick={(e) => op.current.toggle(e)} />
            <OverlayPanel ref={op}>
                <Button label="View Profile" icon="pi pi-user-edit" text  onClick={() => { navigate("/store/user"); }} />
                <br/>
                <Button label="Logout" icon="pi pi-sign-out" onClick={handleLogout} text   />
            </OverlayPanel>
            </div>
      </div>
    </div>
  );
}

export default DashboardPageHeader;